<div class="w100" >
    <div class="pdf-controls">
        <button (click)="prevPage()">⬅️</button>
        <span>Página {{ page }} de {{ totalPages }}</span>
        <button (click)="nextPage()">➡️</button>

        <button (click)="zoomOut()">➖ Zoom</button>
        <button (click)="zoomIn()">➕ Zoom</button>
    </div>
    <pdf-viewer 
        [src]="url" 
        [page]="page" 
        [zoom]="zoom" 
        [render-text]="true" 
        [show-all]="false"
        style="display: block; width: 100%; height: 400px;" 
        (after-load-complete)="onPdfLoad($event)"
    ></pdf-viewer>
</div>